import { BaseProxy } from "@/proxies/BaseProxy";

export class ThreadsProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `threads`,
      parameters,
    });
  }
}
